<template>
    <myhead :value="value" @next="next" @lookmore="more">{{
    $route.query.title || $route.meta.title
  }}</myhead>
  <img :src="info.image" :onerror="imgError" class="radius10 width90 auto block">
</template>
<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import ajax from "@/utils/request.js";

const route = useRoute();
const {query} = route;

const info = ref([
    {image: "@/assets/img/f6f6f6.png"}
]);
ajax.post("joins/getinfo",{cate_id: query.cate_id, id: query.id}).then(res => {
    info.value = res.data
})

</script>
<style scoped>
    img {
        background-color: #f6f6f6;
    }
</style>